// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__KVUxs"};